const USER_MANUAL_URL = `${process.env.PUBLIC_URL}/docs/user-manual.pdf`;
const ENGINEER_MANUAL_URL = `${process.env.PUBLIC_URL}/docs/engineer-manual.pdf`;

export function getManualUrl(isAdmin) {
  return isAdmin ? ENGINEER_MANUAL_URL : USER_MANUAL_URL;
}

export function getManualLabel(isAdmin) {
  return isAdmin ? 'Руководство для инженеров' : 'Руководство пользователя';
}

export function openUserManual(isAdmin) {
  window.open(getManualUrl(isAdmin), '_blank', 'noopener,noreferrer');
}
